import React from "react";
import { Link } from "react-router-dom";
import { Accordion } from "../../components/shared/accordion";
import { Icon } from "@iconify/react/dist/iconify.js";
import _ from "lodash";

import { Img } from "../../components/shared/img";

import { DOWNLOAD_HELP_DATA } from "../data/download-help-data";

/**
 * Componente que muestra las preguntas y respuestas correspondientes a las descargas
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} DownloadHelp
 */
export const DownloadHelp = ({ interfaceTexts }) => {

    const infoDownload = [...DOWNLOAD_HELP_DATA];

    return (
        <>
            <Link to={'/ayuda'} className="secondary-button py-2 px-3">
                <Icon icon="material-symbols:arrow-back-rounded" width="24" height="24" />
                {interfaceTexts?.botones?.volver || 'volver'}
            </Link>

            <h2 className="my-4">{interfaceTexts?.descarga?.titulo || 'Descargas'}</h2>

            <Accordion.Container>
                {
                    infoDownload?.map((item) => {
                        return (
                            <Accordion.Item key={item?.id}>
                                <Accordion.ItemButton
                                    className={'acordeon px-3 py-2'}
                                    label={_.get(interfaceTexts, item?.textButton?.translationPath) || item?.textButton?.default}
                                />
                                <Accordion.Content className={'focusable-secondary opcionAcordeon relative flex-wrap'}>
                                    {
                                        item?.contenido.map(info => {
                                            if (info?.type === "paragraph") {
                                                return (
                                                    <p className="w-100">{_.get(interfaceTexts, info?.translationPath) || info?.default}</p>
                                                )
                                            }
                                            if (info?.type === "img") {
                                                return (
                                                    <Img
                                                        role="presentation" alt="imagen"
                                                        className='img-fluid my-2'
                                                        src={_.get(interfaceTexts, info?.translationPath) || info?.default} />
                                                )
                                            }
                                            if (info?.type === "strong") {
                                                return (<strong className='d-block mb-2'>{_.get(interfaceTexts, info?.translationPath) || info?.default}</strong>)
                                            }
                                            if (info?.type === "title-list") {
                                                return <u className='w-100 
                                                d-block my-3'>{_.get(interfaceTexts, info?.translationPath) || info?.default}</u>
                                            }
                                            if (info?.type === "list") {
                                                return (
                                                    <ol className="w-100 d-block">
                                                        {
                                                            info?.list.map((item) => {
                                                                return (
                                                                    <li key={`${info?.name}-${item?.id}`}>{_.get(interfaceTexts, item?.translationPath) || 'N/A'}</li>
                                                                )
                                                            })
                                                        }
                                                    </ol>
                                                )

                                            }

                                             if (info?.type === "link") {
                                                return <a href={info?.url} className="focusable-secondary enlace mb-3" target='_blank'>{_.get(interfaceTexts, info?.translationPath) || info?.default}</a>
                                            }
                                            
                                        })
                                    }
                                </Accordion.Content>
                            </Accordion.Item>
                        )
                    })
                }
            </Accordion.Container>
        </>
    )
}